import { getJobStatusListLocation } from 'nursd-dashboard/api/jobTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import JobTable from './JobTable';
import { useParams } from 'react-router-dom';
import Flex from 'components/common/Flex';
import classNames from 'classnames';

function Table() {
  const { jobStatus } = useParams();
  const { authToken, location, organization } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nextPage, setNextPage] = useState(0);
  const [previousPage, setPreviousPage] = useState(0);

  useEffect(() => {
    getFacilityJob(1, 20, 'Completed');
  }, [jobStatus]);

  const getFacilityJob = async (page, pageSize, status) => {
    try {
      const itemArr = await getJobStatusListLocation(
        authToken,
        location,
        organization,
        'Shift',
        status,
        page,
        pageSize,
        '',
        ''
      );
      // console.log(itemArr);
      setData(itemArr);
      setNextPage(itemArr?.nextPage);
      setPreviousPage(itemArr?.previousPage);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  return (
    <Card>
      {loading ? (
        <Card.Header>
          <h5 className="mb-0">Loading...</h5>
        </Card.Header>
      ) : (
        <>
          <Card.Body>
            <JobTable data={data?.data} />
          </Card.Body>
          <Card.Footer>
            <Flex
              className={classNames(
                'align-items-center justify-content-between'
              )}
            >
              <Flex alignItems="center" className="fs-10">
                <p className="mb-0">
                  <span className="d-none d-sm-inline-block me-2">
                    {data?.page} to {data?.totalPages} of {data?.totalCount}
                  </span>
                </p>

                <>
                  <p className="mb-0 mx-2">Rows per page:</p>
                  <Form.Select
                    size="sm"
                    className="w-auto"
                    onChange={e => {
                      getFacilityJob(1, e.target.value, 'Completed');
                    }}
                    defaultValue={data?.pageSize}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                  </Form.Select>
                </>
              </Flex>
              <Flex>
                <Button
                  size="sm"
                  variant={previousPage !== null ? 'primary' : 'tertiary'}
                  onClick={() => {
                    if (jobStatus === 'All') {
                      getFacilityJob(previousPage, 10, status?.label);
                    } else {
                      getFacilityJob(previousPage, 10, jobStatus);
                    }
                  }}
                  className={classNames({
                    disabled: previousPage !== null ? false : true
                  })}
                >
                  Previous
                </Button>
                <Button
                  size="sm"
                  variant={nextPage !== null ? 'primary' : 'tertiary'}
                  className={classNames('px-4 ms-2', {
                    disabled: nextPage !== null ? false : true
                  })}
                  onClick={() => {
                    if (jobStatus === 'All') {
                      getFacilityJob(nextPage, 10, status?.label);
                    } else {
                      getFacilityJob(nextPage, 10, jobStatus);
                    }
                  }}
                >
                  Next
                </Button>
              </Flex>
            </Flex>
          </Card.Footer>
        </>
      )}
    </Card>
  );
}

export default Table;
